import { ReactElement, ReactNode } from 'react';

import FeatureSubscriptionsEditingContext from '../contexts/feature-subscriptions-editing-provider-context';
import useFeatureSubscriptionsEditing from '../hooks/feature-subscriptions-editing';

type FeatureSubscriptionsEditingProviderProps = {
  children: ReactNode;
};

const FeatureSubscriptionsEditingProvider = ({ children }: FeatureSubscriptionsEditingProviderProps): ReactElement => (
  <FeatureSubscriptionsEditingContext value={useFeatureSubscriptionsEditing()}>{children}</FeatureSubscriptionsEditingContext>
);

export default FeatureSubscriptionsEditingProvider;
